// @ts-check
/**
 * Typed client for the opportunities API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['CheckEnrollmentRequest']} CheckEnrollmentRequest */
/** @typedef {Schemas['CheckEnrollmentResponse']} CheckEnrollmentResponse */
/** @typedef {Schemas['EnrollPatientRequest']} EnrollPatientRequest */
/** @typedef {Schemas['EnrollPatientSuccessResponse']} EnrollPatientSuccessResponse */

/**
 * POST /api/opportunities/check-enrollment/ — fetch a patient's enrolled opportunities.
 *
 * @param {CheckEnrollmentRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<CheckEnrollmentResponse>}
 */
export async function checkEnrollment(body, config) {
  const { data } = await axios.post('/api/opportunities/check-enrollment/', body, config)
  return data
}

/**
 * POST /api/opportunities/enroll-patient/ — manually enroll one patient.
 *
 * Frontend callers must provide metric_id, a resolved entity_id when available,
 * and first_task_due_date. The API keeps the date optional temporarily for
 * legacy integrations, and normalizes weekend/holiday dates.
 *
 * @param {EnrollPatientRequest} body
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<EnrollPatientSuccessResponse>}
 */
export async function enrollPatient(body, config) {
  const { data } = await axios.post('/api/opportunities/enroll-patient/', body, config)
  return data
}
